export default "__VITE_ASSET__cba9cfa0__"